import { useCallback, useRef } from 'react';
import { KeyCode } from '../../../keycode';
var HOME = 36;
var END = 35;
export var useMenuKeyboard = function (_a) {
    var moveHighlight = _a.moveHighlight, selectOption = _a.selectOption, goHome = _a.goHome, goEnd = _a.goEnd, closeDropdown = _a.closeDropdown, isKeyboard = _a.isKeyboard, isSelectingUsingSpace = _a.isSelectingUsingSpace, _b = _a.preventNativeSpace, preventNativeSpace = _b === void 0 ? false : _b;
    return useCallback(function (e) {
        isKeyboard.current = true;
        switch (e.detail.keyCode) {
            case KeyCode.up:
                e.preventDefault();
                moveHighlight(-1);
                break;
            case KeyCode.down:
                e.preventDefault();
                moveHighlight(1);
                break;
            case HOME:
                goHome();
                break;
            case END:
                goEnd();
                break;
            case KeyCode.escape:
                closeDropdown();
                break;
            case KeyCode.enter:
                e.preventDefault();
                selectOption();
                break;
            case KeyCode.space:
                if (preventNativeSpace) {
                    e.preventDefault();
                    selectOption();
                    isSelectingUsingSpace.current = true;
                }
        }
    }, [moveHighlight, selectOption, goHome, goEnd, closeDropdown, isKeyboard, isSelectingUsingSpace, preventNativeSpace]);
};
export var useTriggerKeyboard = function (_a) {
    var openDropdown = _a.openDropdown, goHome = _a.goHome, isKeyboard = _a.isKeyboard;
    return useCallback(function (e) {
        isKeyboard.current = true;
        switch (e.detail.keyCode) {
            case KeyCode.up:
            case KeyCode.down:
                e.preventDefault();
                goHome();
                openDropdown();
                break;
            case KeyCode.space:
                e.preventDefault();
                openDropdown();
                break;
        }
    }, [openDropdown, goHome, isKeyboard]);
};
/**
 * Firefox has a bug whereby a canceled space key event will still
 * cause a click event on a button: https://bugzilla.mozilla.org/show_bug.cgi?id=1487102
 *
 * Therefore, we track whether the dropdown is being closed as the result
 * of a space-key selection, and prevent it from being immediately
 * reopened in this case.
 */
export var useSpaceAwareClickHandler = function (_a) {
    var isSelectingUsingSpace = _a.isSelectingUsingSpace, toggleDropdown = _a.toggleDropdown;
    var skipImmediateClick = useRef(false);
    return {
        triggerClickHandler: useCallback(function () {
            if (!skipImmediateClick.current) {
                toggleDropdown();
            }
        }, [toggleDropdown]),
        triggerKeyUpHandler: function (e) {
            if (e.detail.keyCode === KeyCode.space && isSelectingUsingSpace.current) {
                skipImmediateClick.current = true;
                setTimeout(function () { return (skipImmediateClick.current = false); }, 0);
            }
        }
    };
};
